import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Rate, Button, Carousel, App, Pagination } from 'antd';
import styles from './index.module.scss';
import { useNavigate, useParams } from 'react-router-dom';
import { getProductDetail } from '@/api/products';
import { saveToCart } from '@/api/cart';
import { HeartOutlined, HeartFilled } from '@ant-design/icons';
import { useAppSelector } from '@/store/hooks';
import { createChatRoom } from '@/api/message';
import {
  getWebStoreDetail,
  getWebStoreChannel,
  saveUserFollow,
  getCheckIsFollow,
  getMerchantInfo
} from '@/api/store';

import pic1 from '@/assets/images/Merchant _url.png';

import ProductList from '../Home/components/ProductList/ProductList';
import { useTranslation } from 'react-i18next';

const StoreDetail: React.FC = () => {
  const navigate = useNavigate();
  const params2 = useParams();
  const { message } = App.useApp();
  //国际化语言切换
  const { t, i18n } = useTranslation();
  // 获取用户信息
  const userInfo = useAppSelector((state) => state.user.userInfo);

  //是否关注
  const [isFollow, setIsFollow] = useState(false);

  // 主导航标签
  const [mainTabs, setMainTabs] = useState<any[]>([]);

  const [selectedMainTab, setSelectedMainTab] = useState(0);

  // 子导航过滤器
  const [subFilters, setSubFilters] = useState([
    'General', 'Sales', 'New Item', 'Price +'
  ]);

  const [selectedSubFilter, setSelectedSubFilter] = useState(0);

  //商品入参
  const [params, setParams] = useState<any>({
    merchant_channel_id: '',
    merchant_id: '',
    page_num: 1,
    page_size: 20,
    total: 0,
    totalPages: 0,
    keyword: ''
  });

  // 分页信息
  const [goToPage, setGoToPage] = useState<string>('');


  // 模拟产品数据
  const [goodsList, setGoodsList] = useState([

  ]);

  // 店铺详情
  const [merchantInfo, setMerchantInfo] = useState<any>({});


  //获取商品列表方法
  const getProductListFn = (paramsTop: any) => {
    getWebStoreDetail(paramsTop).then((res) => {
      if (res.code == 200) {
        setGoodsList(res.data);
        setParams((prevParams: any) => ({
          ...prevParams,
          page_num: params.page_num,
          total: res.total || 0,
          totalPages: res.totalPages || 1,
        }));
        setGoToPage('');
      }
    })
  }

  // 获取店铺频道
  const getWebStoreChannelFn = (paramsTop: any) => {
    getWebStoreChannel(paramsTop).then((res) => {
      if (res.code == 200) {
        res.data.unshift({
          merchant_channel_id: '0',
          merchant_channel_name: t('common.All')
        });
        setMainTabs(res.data);

        // 默认加载商品的搜索
        const myParams = {
          ...params,
          merchant_channel_id: res.data[0]?.merchant_channel_id,
          merchant_id: params2.id

        };

        setParams(myParams);

        getProductListFn(myParams);

      }
    })
  }





  // 处理页码输入框回车事件
  const handlePageInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleGoToPage();
    }
  };

  // 分页变化
  const paginationChange = (page: number, pageSize: number) => {
    console.log('page', page, pageSize);

    const myParams = {
      ...params,
      page_num: page,
      page_size: pageSize,
    };
    setParams(myParams);
    getProductListFn(myParams);

  };

  // 跳转到指定页
  const handleGoToPage = () => {
    const page = parseInt(goToPage);
    if (isNaN(page) || page < 1) {
      return;
    }


    if (page > params.totalPages) {
      return;
    }

    const myParams = {
      ...params,
      page_num: page,
    };
    setParams(myParams);
    getProductListFn(myParams);


  };

  // 关键字搜索
  const SearchAction = () => {
    const myParams = {
      ...params,
      page_num: 1,
    };
    setParams(myParams);
    getProductListFn(myParams);
  }

  // 处理主导航标签点击
  const handleMainTabClick = (index: number, tab: any) => {
    setSelectedMainTab(index);


    const myParams = {
      ...params,
      merchant_channel_id: tab?.merchant_channel_id,
      page_num: 1,
    }
    setParams(myParams);
    getProductListFn(myParams);
  };

  // 处理子过滤器点击
  const handleSubFilterClick = (index: number) => {
    setSelectedSubFilter(index);
  };

  // 关注
  const handleFollow = () => {
    saveUserFollow({ follow_id: params2.id, is_delete: false }).then((res) => {
      if (res.code == 200) {
        setIsFollow(true);
      } else {
        message.error(res.message);
      }
    })
  }
  // 取消关注
  const handleCancelFollow = () => {
    saveUserFollow({ follow_id: params2.id, is_delete: true }).then((res) => {
      if (res.code == 200) {
        setIsFollow(false);
      } else {
        message.error(res.message);
      }
    })
  }


  //mounted 和unmounted
  useEffect(() => {

    //获取店铺频道
    getWebStoreChannelFn({ merchant_id: params2.id });

    //获取店铺详情
    getMerchantInfo({ merchant_id: params2.id }).then((res) => {
      if (res.code == 200) {
        setMerchantInfo(res.data);
      }
    })


    //登录状态下查看是否已关注店铺
    if (userInfo) {
      getCheckIsFollow({ follow_id: params2.id }).then((res) => {
        if (res.code == 200) {
          setIsFollow(res.data);
        }
      })
    }


  }, []);


  return (
    <div className={styles['store-detail']}>
      {/* 搜索栏 */}
      <div className={styles['search-header']}>
        <div className={styles['search-container']}>
          <input
            type="text"
            value={params.keyword}
            onChange={(e) => setParams({
              ...params,
              keyword: e.target.value
            })}
            placeholder={t('LiveStreamingProduct.TableLamp')}
            className={styles['search-input']}
          />
          <button className={styles['search-button']} onClick={SearchAction}>{t('common.Search')}</button>
        </div>
        <div className={styles['header-buttons']}>
          {/* <button className={styles['csr-button']}>CSR</button> */}
          {isFollow ? (
            <button className={styles['follow-button']} onClick={handleCancelFollow}>{t('common.Following')}</button>
          ) : (
            <button className={styles['follow-button']} onClick={handleFollow}>+ {t('common.Follow')}</button>
          )}

        </div>
      </div>

      {/* 店铺信息头部 */}
      <div className={styles['store-header']}>
        <div className={styles['store-info']}>
          <img src={merchantInfo?.merchant_logo_file_url || pic1} alt="Store Logo" className={styles['store-logo']} />
          <div className={styles['store-details']}>
            <h1 className={styles['store-name']}>{merchantInfo?.merchant_name}</h1>
            <div className={styles['store-rating']}>
              <Rate value={5} disabled className={styles['rating-stars']} />
              <span className={styles['rating-text']}>5</span>
            </div>
            <div className={styles['store-followers']}>28 {t('common.Follow')}</div>
            {/* <div className={styles['store-metrics']}>
              <div className={styles['metric-item']}>
                <span className={styles['metric-label']}>Experience</span>
                <span className={styles['metric-value']}>4.1+</span>
          </div>
              <div className={styles['metric-item']}>
                <span className={styles['metric-label']}>Product Quality</span>
                <span className={styles['metric-value']}>4.7+</span>
          </div>
              <div className={styles['metric-item']}>
                <span className={styles['metric-label']}>Logistics Speed</span>
                <span className={styles['metric-value']}>4.9+</span>
        </div>
              <div className={styles['metric-item']}>
                <span className={styles['metric-label']}>Service Guarantee</span>
                <span className={styles['metric-value']}>3.3+</span>
            </div>
          </div> */}
          </div>
        </div>
      </div>

      {/* 主导航标签 */}
      <div className={styles['main-navigation']}>
        {mainTabs.map((tab, index) => (
          <button
            key={index}
            className={`${styles['main-tab']} ${selectedMainTab === index ? styles['main-tab-active'] : ''}`}
            onClick={() => handleMainTabClick(index, tab)}
          >
            {tab?.merchant_channel_name}
          </button>
        ))}
      </div>

      {/* 子导航过滤器 */}
      {/* <div className={styles['sub-navigation']}>
        {subFilters.map((filter, index) => (
          <button
            key={index}
            className={`${styles['sub-filter']} ${selectedSubFilter === index ? styles['sub-filter-active'] : ''}`}
            onClick={() => handleSubFilterClick(index)}
          >
            {filter}
          </button>
        ))}
          </div> */}

      {/* 产品列表 */}
      <div className={styles['products-section']}>
        <ProductList goodsList={goodsList} isShowTop={false} />
        {goodsList.length > 0 &&
          <div className={styles['pagination-container']}>
            <div className={styles['pagination-info']}>Total {params.total} Products</div>
            <Pagination
              onChange={paginationChange}
              current={params.page_num}
              pageSize={params.page_size}
              total={params.total}
              showSizeChanger={false}
              responsive
              hideOnSinglePage={params.totalPages <= 1}
            />
            <div className={styles['go-to-page']}>
              go to
              <input
                className={styles['page-input']}
                type="text"
                value={goToPage}
                onChange={(e) => setGoToPage(e.target.value)}
                onKeyDown={handlePageInputKeyDown}
              />
              page
              <Button
                size="small"
                style={{ marginLeft: 8 }}
                onClick={handleGoToPage}
              >
                GO
              </Button>
            </div>
          </div>
        }
      </div>
    </div>
  );
};

export default StoreDetail; 